import { fontWeightMap } from 'helpers/constants';

// Helper function to resolve URL and target for Next.js Link
export const getResolvedHref = (url: any): string => {
  if (!url) return '#';
  if (typeof url === 'string') return url;

  // Handle Reference type URLs
  if (url.type === 'link') {
    return url.link || url.target || '#';
  }
  if (url.type === 'page-folder') {
    return url.pageFolder?._url || '#';
  }

  return '#';
};

// Helper function to determine if link should open in new window
export const shouldOpenInNewWindow = (url: any): boolean => {
  if (!url || typeof url === 'string') return false;
  return url.openInNewWindow === true;
};

// Helper function to get heading styles
export const getHeadingStyles = (heading: any, isDesktopSize: boolean) => {
  if (!heading?.[0]) return {};
  return {
    fontSize: isDesktopSize ? `${heading[0].fontSizeDesktop}px` : `${heading[0].fontSizeMobile}px`,
    color: isDesktopSize?heading[0].fontColor:(heading[0].fontColorMobile??'#333333'),
    fontWeight:isDesktopSize?fontWeightMap[heading[0]?.textStyle??'regular']:fontWeightMap[heading[0]?.textStyleMobile??'regular'],
    ...( !isDesktopSize && { textAlign:  heading[0]?.elementPosition} ),
  };
};

// Mobile position mapping: left -> top, right -> bottom, center -> center
export function getMobilePosition(desktopPosition: string): string {
  switch (desktopPosition?.toLowerCase()) {
    case 'left':
      return 'top';
    case 'right':
      return 'bottom';
    case 'center':
    default:
      return 'center';
  }
}

export function getPositionClasses(position: string, isDesktopSize: boolean): string {
  if (isDesktopSize) {
    // Desktop positioning
    switch (position?.toLowerCase()) {
      case 'left':
        return 'left-0 top-0 h-full';
      case 'right':
        return 'right-0 top-0 h-full';
      case 'center':
        return 'left-1/2 top-0 h-full transform -translate-x-1/2';
      default:
        return 'left-0 top-0 h-full';
    }
  } else {
    // Mobile positioning - responsive mapping
    const mobilePosition = getMobilePosition(position);
    switch (mobilePosition) {
      case 'top':
        return 'left-1/2 top-0 transform -translate-x-1/2 w-full';
      case 'bottom':
        return 'left-1/2 bottom-0 transform -translate-x-1/2 w-full';
      case 'center':
      default:
        return 'left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full';
    }
  }
}

export function getMobileJustifyClasses(position: string, isDesktopSize: boolean): string {
  if (isDesktopSize) {
    // Desktop justify classes
    return position === 'center' ? 'justify-center' : 'justify-end pb-20';
  } else {
    // Mobile justify classes based on mapped position
    const mobilePosition = getMobilePosition(position);
    switch (mobilePosition) {
      case 'top':
        return 'justify-start pt-20';
      case 'bottom':
        return 'justify-end pb-20';
      case 'center':
      default:
        return 'justify-center';
    }
  }
}

export function getPositionClassesForAll(position: string): string {
  switch (position?.toLowerCase()) {
      case 'left':
        return 'left-0 top-0 h-full justify-center';
      case 'right':
        return 'right-0 top-0 h-full justify-center';
      case 'center':
        return 'left-1/2 h-full transform -translate-x-1/2 justify-end w-full top-20';
      default:
        return 'left-0 top-0 h-full';
    }
}